import { render, staticRenderFns } from "./ViewResult.vue?vue&type=template&id=f02247ae&"
import script from "./ViewResult.vue?vue&type=script&lang=js&"
export * from "./ViewResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports